module.exports = "../study/imgs/maps/Kanagawa/S8/Ecosystem/Qacuta/Kanagawa_Qacuta_MRI_RCP85_Mid.png";